import { Handle, Position } from '@xyflow/react'

/**
 * RuleAnimTimeNode — outputs a float from the current animation clip's timing.
 *
 * data.subtype:
 *   'remaining' → outputs seconds remaining in the clip (default 999 if no timing)
 *   'ratio'     → outputs 0→1 ratio through the clip (default 0)
 *
 * data._debugValue — injected by TransitionRuleEditor polling debugState.clipTimings
 */
export function RuleAnimTimeNode({ data }) {
  const isRatio      = data.subtype === 'ratio'
  const label        = isRatio ? 'ANIM FRACTION' : 'ANIM TIME REMAINING'
  const unit         = isRatio ? '' : 's'
  const debugVal     = data._debugValue
  const hasVal       = debugVal !== undefined && debugVal !== null
  const clipName     = data.activeClipName   // which clip the evaluator reads
  const noClip       = !clipName

  return (
    <div style={{
      background: '#1e1500',
      border: `2px solid ${noClip ? '#804010' : '#c07820'}`,
      borderRadius: 6,
      padding: '8px 12px',
      minWidth: 160,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 11,
    }}>
      {/* Header */}
      <div style={{ color: '#e09030', fontWeight: 'bold', fontSize: 9, letterSpacing: 1, marginBottom: 6 }}>
        {label}
      </div>

      {/* Live value */}
      <div style={{
        background: '#120e00',
        border: '1px solid #604010',
        borderRadius: 3,
        padding: '3px 8px',
        fontSize: 12,
        color: hasVal ? '#ffc040' : '#403820',
        textAlign: 'center',
      }}>
        {hasVal
          ? isRatio
            ? (debugVal * 100).toFixed(1) + '%'
            : debugVal.toFixed(2) + unit
          : '—'
        }
      </div>

      {/* Clip source */}
      <div style={{
        marginTop: 5,
        fontSize: 8,
        color: noClip ? '#c04020' : '#806040',
        letterSpacing: 0.5,
      }}>
        {noClip ? '⚠ no active state' : `clip: ${clipName}`}
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="out"
        style={{ background: '#c07820', width: 10, height: 10 }}
      />
    </div>
  )
}
